import globalImage from "common/img/results-global.jpg";
import transportImage from "common/img/results-transport.jpg";
import energyImage from "common/img/results-energy.jpg";
import nutritionImage from "common/img/results-nutrition.jpg";
import householdHabitsImage from "common/img/results-household-habits.jpg";

export interface Sector {
  title: string;
  color: string;
  image: string;
}

export const SECTORS: Sector[] = [
  {
    title: "Global",
    color: "#3c64b1",
    image: globalImage,
  },
  {
    title: "Movilidad",
    color: "#a6b30a",
    image: transportImage,
  },
  {
    title: "Energía",
    color: "#306ba5",
    image: energyImage,
  },
  {
    title: "Alimentación",
    color: "#e37222",
    image: nutritionImage,
  },
  {
    title: "Hábitos de hogar",
    color: "#e8153b",
    image: householdHabitsImage,
  },
];
